import React from 'react';
import { Routes, Route } from 'react-router-dom';
import DPLogin from './Login';
import Rides from './Rides';

function App() {
  return (

      <Routes>
        <Route path='/delivery' element={<DPLogin/>} />
        <Route path='/delivery/rides' element={<Rides/>} />
      </Routes>
  );
}

export default App;
